import { render, staticRenderFns } from "./DeleteConfirm.vue?vue&type=template&id=4295c0b0&scoped=true"
import script from "./DeleteConfirm.vue?vue&type=script&lang=js"
export * from "./DeleteConfirm.vue?vue&type=script&lang=js"
import style0 from "./DeleteConfirm.vue?vue&type=style&index=0&id=4295c0b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4295c0b0",
  null
  
)

export default component.exports